// Dependencies
import React from 'react'

const ButtonFormSubmit = (props) => {
  return (
    <button className={`bg-[#06BD60] text-white px-6 py-2 rounded-sm text-center text-base font-medium cursor-pointer ${props.overrideStyles}`} type='submit'>
        {props.buttonText}
    </button>
  )
}

export default ButtonFormSubmit